import { Component, OnInit } from '@angular/core';
import { SupportService } from 'app/shared/support.service';

@Component({
  selector: 'app-aspera-desktop-migration',
  templateUrl: './aspera-desktop-migration.component.html',
  styleUrls: ['./aspera-desktop-migration.component.scss']
})
export class AsperaDesktopMigrationComponent implements OnInit {
  supportLink: string;

  constructor(
    private supportService: SupportService
  ) {
    this.supportLink = this.supportService.link;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/help/aspera-desktop-migration/aspera-desktop-migration.component.ts